import { put, takeEvery } from "redux-saga/effects";
import { GET_ENHANCED_AUTH_BENEFITS } from "../action";
import { benefitsLookupStart } from "../../../action";
import { datadogRum } from "@datadog/browser-rum";
import { checkEnhancedAuthMessageData, isValidPartnerCodeForEnhancedAuth } from "../helper/checkEnhancedAuthMessageData"

export function* getEnhancedAuthBenefits(action) {
    if(action && action.payload) {
      const {partnerCode, ...messageData} = action.payload;
      const isEnhancedBenefitPartner = isValidPartnerCodeForEnhancedAuth(partnerCode)
      //only go inside if its enhanced auth partner
      if (isEnhancedBenefitPartner) {
        try {
          const isValid = checkEnhancedAuthMessageData(messageData, partnerCode);
          if (!isValid && partnerCode) {
            datadogRum.addError(`Invalid message data for partnerCode: ${partnerCode}`, messageData);
            return;
          }
          // setting enhancedAuthFlow to true for enhanced auth flow
          yield put(benefitsLookupStart({enhancedAuthFlow: true, ...messageData}, history));
        } catch (error) {
          datadogRum.addError("Error in getEnhancedAuthBenefitsSaga", error);
        }
      }
    }
}

export function* watchGetEnhancedAuthBenefitsSaga() {
  yield takeEvery(GET_ENHANCED_AUTH_BENEFITS, getEnhancedAuthBenefits);
}
